import dom_elements from "../main/dom-elements";
import { debounceRAF } from "../utils/timing";


export class ScrollContentProgressBar {

    constructor(
        progressBarSelector, 
        targetContentSelector
    ) {

        this.progressBar = document.querySelector(progressBarSelector);

        console.log(this.progressBar, progressBarSelector);

        this.content = document.querySelector(targetContentSelector);

        if (this.progressBar === null || this.content === null) {

            console.warn('Progress bar not init');

        }

        this.contentHeight = this.content.offsetHeight;
        this.contentTop = this.content.offsetTop;

        this.updateProgress();
        window.addEventListener('scroll', debounceRAF(() => this.updateProgress()));

    }

    updateProgress() {

        const scroll_top = window.scrollY;

        const scroll_in_content = scroll_top - this.contentTop;

        const progress = Math.min(Math.max(scroll_in_content / (this.contentHeight - window.innerHeight), 0), 1);

        const progressRounded = Math.round(progress * 100);

        this.progressBar.dataset.percentage = progressRounded
        this.progressBar.setAttribute('aria-valuenow', progressRounded)
        this.progressBar.style.setProperty('--value-now', progressRounded);

    }

}


// const progress_bar = dom_elements.then(() => {
//     return {

//         init: () => {

//             const progressBar = document.querySelector('#progress-bar')

//             if (window.getComputedStyle(progressBar).display !== 'none') {

//                 const article = document.body.querySelector(":scope > main > article")

//                 const article_height = article.offsetHeight,
//                       article_top = article.offsetTop;

//                 window.addEventListener('scroll', () => {

//                     const scroll_top = window.scrollY;

//                     const scroll_in_article = scroll_top - article_top;

//                     const progress = Math.min(Math.max(scroll_in_article / (article_height - window.innerHeight), 0), 1);

//                     const progressRounded = Math.round(progress * 100)

//                     progressBar.dataset.percentage = progressRounded
//                     progressBar.setAttribute('aria-valuenow', progressRounded)
//                 })

//             }

//         }

//     }
// })

// export default progress_bar